import pMinDelay from 'p-min-delay';
import React, { lazy, Suspense } from 'react';
import LoaderPage from '../loader-page';
export const Loadable = (importFunc: any, fallback: any) => {
  const LazyComponent = lazy(importFunc);
  // Chấp nhận cả Loadable(fn, <Loader />) lẫn Loadable(fn, { fallback: <Loader /> })
  const fallbackElement =
    fallback && typeof fallback === 'object' && !React.isValidElement(fallback) && 'fallback' in fallback
      ? fallback.fallback
      : fallback;

  return (props: any) => (
    <Suspense fallback={fallbackElement}>
      <LazyComponent {...props} />
    </Suspense>
  );
};

export const LazyPage = (importFunc: any) => {
  const LazyComponent = lazy(() => pMinDelay(importFunc, 250));

  return () => (
    <Suspense fallback={<LoaderPage />}>
      <LazyComponent />
    </Suspense>
  );
}